<template>
    <el-row v-if="activeStyle == 2 ? true : false">
        <el-form ref="form" label-width="120px" :model="addBasicInfoForm" style="font-size: 14px">
            <el-col :span="12">
                <el-form-item label="名称">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="编码">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="类别">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="级别">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="省份">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="城市">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="地址">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系电话">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="邮政编码">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="官方网址">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="所属经销商">
                    <el-input v-model="basicInfoForm.name" ></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="开发进度">
                <el-select v-model="basicInfoForm.TerritoryList" placeholder="请选择开发进度" style="width: 100%">
                    <el-option
                            v-for="item in TerritoryList"
                            :key="item.territory_id"
                            :label="item.territory_name"
                            :value="item.territory_id"
                    >
                    </el-option>
                </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="已进药">
                    <el-switch
                            v-model="value"
                            active-color="#13ce66">
                    </el-switch>
                </el-form-item>
            </el-col>
        </el-form>
    </el-row>
    <el-row v-else>
        <el-form ref="form" label-width="120px" :model="basicInfoForm" style="font-size: 14px">
            <el-col :span="12">
                <el-form-item label="名称">
                    <el-input v-model="basicInfoForm.institution_name" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="编码">
                    <el-input v-model="basicInfoForm.institution_code" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="类别">
                    <el-select v-model="basicInfoForm.institution_type" placeholder="" disabled style="width: 100%">
                        <el-option
                                v-for="item in TerritoryList"
                                :key="item.territory_id"
                                :label="item.territory_name"
                                :value="item.territory_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="级别">
                    <el-select v-model="basicInfoForm.institution_grade" placeholder="" disabled style="width: 100%">
                        <el-option
                                v-for="item in TerritoryList"
                                :key="item.territory_id"
                                :label="item.territory_name"
                                :value="item.territory_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="省份">
                    <el-select v-model="basicInfoForm.province_id" placeholder="" disabled style="width: 100%">
                        <el-option
                                v-for="item in TerritoryList"
                                :key="item.territory_id"
                                :label="item.territory_name"
                                :value="item.territory_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="城市">
                    <el-select v-model="basicInfoForm.city_id" placeholder="" disabled style="width: 100%">
                        <el-option
                                v-for="item in TerritoryList"
                                :key="item.territory_id"
                                :label="item.territory_name"
                                :value="item.territory_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item label="地址">
                    <el-input v-model="basicInfoForm.address" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="联系电话">
                    <el-input v-model="basicInfoForm.telephone" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="邮政编码">
                    <el-input v-model="basicInfoForm.postcode" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="官方网址">
                    <el-input v-model="basicInfoForm.website" disabled></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="所属经销商">
                    <el-select v-model="basicInfoForm.distributor_id" placeholder="" disabled style="width: 100%">
                        <el-option
                                v-for="item in TerritoryList"
                                :key="item.territory_id"
                                :label="item.territory_name"
                                :value="item.territory_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="开发进度">
                    <el-select v-model="basicInfoForm.agreement_stage" placeholder="" disabled style="width: 100%">
                        <el-option
                                v-for="item in TerritoryList"
                                :key="item.territory_id"
                                :label="item.territory_name"
                                :value="item.territory_id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="已进药">
                    <el-switch
                            v-model="agreement_signed"
                            active-color="#13ce66"
                            disabled>
                    </el-switch>
                </el-form-item>
            </el-col>
        </el-form>
    </el-row>

</template>

<script>
    export default {
        name: "chooseType",
        props:{
            activeStyle: {
                type: Number,
                default: 0
            },
            institution_id: {
                type: String,
                default: ''
            },
            basicInfoForm: {
                type: Object,
                default: {}
            },
        },
        data(){
            return {
                addBasicInfoForm:{},
            }
        },
        created() {

        },
        methods:{

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/jurmanage/components/basicInfo.vue